var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "py-4" },
    [
      _c("modal-filter", {
        attrs: { onfilter: _vm.onfilter, filter: _vm.filter, exclude: [] },
        on: {
          onclose: function ($event) {
            _vm.onfilter = false
          },
          onfilter: function ($event) {
            return _vm.ONFILTER()
          },
        },
      }),
      _vm._v(" "),
      _vm.ondelete
        ? _c("modal-delete", {
            attrs: { ondelete: _vm.ondelete, id: _vm.id },
            on: {
              onclose: function ($event) {
                _vm.ondelete = false
              },
              onreload: function ($event) {
                return _vm.ONFILTER()
              },
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.onreload
        ? _c("modal-reload", {
            attrs: { onreload: _vm.onreload, item: _vm.item },
            on: {
              onclose: function ($event) {
                _vm.onreload = false
              },
              onreload: _vm.FRESH,
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _c("header", [
        _c("div", { staticClass: "container-fluid" }, [
          _c("div", { staticClass: "pb-4" }, [
            _c("div", { staticClass: "row align-items-end" }, [
              _vm._m(0),
              _vm._v(" "),
              _c("div", { staticClass: "col-sm-auto col-12 mt-4 mt-sm-0" }, [
                _c(
                  "div",
                  { staticClass: "hstack gap-2 justify-content-sm-end" },
                  [
                    _c(
                      "router-link",
                      { attrs: { to: { name: "DeliverRouteCreate" } } },
                      [
                        _c(
                          "button",
                          {
                            staticClass: "btn btn-h btn-primary px-3",
                            attrs: { type: "button" },
                          },
                          [_c("span", [_vm._v("Crear")])]
                        ),
                      ]
                    ),
                  ],
                  1
                ),
              ]),
            ]),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c("main", [
        _c("div", { staticClass: "container-fluid" }, [
          _c("div", { staticClass: "vstack gap-4" }, [
            _c(
              "div",
              {
                staticClass:
                  "d-flex flex-column flex-md-row gap-3 justify-content-between",
              },
              [
                _c(
                  "form",
                  {
                    staticClass: "d-flex gap-3 row",
                    on: {
                      submit: function ($event) {
                        $event.preventDefault()
                        return _vm.FILTER()
                      },
                    },
                  },
                  [
                    _c("div", [
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-h px-3 btn-neutral",
                          attrs: { type: "button" },
                          on: {
                            click: function ($event) {
                              _vm.onfilter = true
                            },
                          },
                        },
                        [
                          _c("i", { staticClass: "bi bi-funnel me-2" }),
                          _vm._v(" "),
                          _c("span", [_vm._v("Filtro")]),
                          _vm._v(" "),
                          _c("span", { staticClass: "vr opacity-20 mx-3" }),
                          _vm._v(" "),
                          _c("span", { staticClass: "text-xs text-primary" }, [
                            _vm._v(_vm._s(_vm.count_filter)),
                          ]),
                        ]
                      ),
                    ]),
                    _vm._v(" "),
                    _c("div", [
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-h px-3 btn-neutral",
                          attrs: { type: "button" },
                          on: {
                            click: function ($event) {
                              return _vm.SORT()
                            },
                          },
                        },
                        [
                          _c("i", {
                            staticClass: "me-2",
                            class:
                              _vm.filter.sortDesc == "ASC"
                                ? "bi bi-sort-alpha-up"
                                : "bi bi-sort-alpha-down-alt",
                          }),
                          _vm._v(" "),
                          _c("span", [_vm._v(_vm._s(_vm.filter.sortDesc))]),
                        ]
                      ),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-md-2 px-0" }, [
                      _c(
                        "div",
                        {
                          staticClass:
                            "input-group input-group-sm input-group-inline",
                        },
                        [
                          _vm._m(1),
                          _vm._v(" "),
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.filter.search,
                                expression: "filter.search",
                              },
                            ],
                            staticClass: "form-control",
                            attrs: { type: "text", placeholder: "Buscar No." },
                            domProps: { value: _vm.filter.search },
                            on: {
                              keypress: _vm.NUMBER,
                              input: function ($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.$set(
                                  _vm.filter,
                                  "search",
                                  $event.target.value
                                )
                              },
                            },
                          }),
                        ]
                      ),
                    ]),
                    _vm._v(" "),
                    _c("div", [
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-h px-3 btn-primary",
                          attrs: { type: "submit" },
                        },
                        [
                          _vm.loading == "filter"
                            ? _c(
                                "div",
                                {
                                  staticClass:
                                    "spinner-border spinner-border-sm",
                                  attrs: { role: "status" },
                                },
                                [
                                  _c("span", { staticClass: "sr-only" }, [
                                    _vm._v("Loading..."),
                                  ]),
                                ]
                              )
                            : _c("span", [_vm._v("Buscar")]),
                        ]
                      ),
                    ]),
                    _vm._v(" "),
                    _c("div", [
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-h px-3 btn-danger",
                          attrs: { type: "button" },
                          on: {
                            click: function ($event) {
                              return _vm.CLEAR()
                            },
                          },
                        },
                        [
                          _vm.loading == "clear"
                            ? _c(
                                "div",
                                {
                                  staticClass:
                                    "spinner-border spinner-border-sm",
                                  attrs: { role: "status" },
                                },
                                [
                                  _c("span", { staticClass: "sr-only" }, [
                                    _vm._v("Loading..."),
                                  ]),
                                ]
                              )
                            : _c("span", [_vm._v("Limpiar")]),
                        ]
                      ),
                    ]),
                  ]
                ),
              ]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "card" }, [
              _vm._m(2),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "card-body p-0" },
                [
                  [
                    _c("v-data-table", {
                      staticClass: "elevation-1",
                      attrs: {
                        headers: _vm.headers,
                        items:
                          _vm.loading == "table" ||
                          _vm.loading == "sort" ||
                          _vm.loading == "filter" ||
                          _vm.loading == "clear"
                            ? []
                            : _vm.items.data,
                        options: _vm.options,
                        "server-items-length": _vm.items.total,
                        loading:
                          _vm.loading == "table" ||
                          _vm.loading == "sort" ||
                          _vm.loading == "filter" ||
                          _vm.loading == "clear",
                        "footer-props": {
                          "items-per-page-options": [5, 10, 50, 100],
                        },
                      },
                      on: {
                        "update:options": function ($event) {
                          _vm.options = $event
                        },
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "item.state_id",
                            fn: function (ref) {
                              var item = ref.item
                              return [
                                item.state_id == 26
                                  ? _c(
                                      "span",
                                      {
                                        staticClass:
                                          "badge badge-secondary badge-pill",
                                      },
                                      [_vm._v("Entregada al chofer")]
                                    )
                                  : _c(
                                      "span",
                                      {
                                        staticClass:
                                          "badge badge-secondary badge-pill",
                                      },
                                      [_vm._v("Creada")]
                                    ),
                              ]
                            },
                          },
                          {
                            key: "item.date",
                            fn: function (ref) {
                              var item = ref.item
                              return [
                                _vm._v(
                                  "\n                                    " +
                                    _vm._s(_vm._f("DATE")(item.date)) +
                                    "\n                                "
                                ),
                              ]
                            },
                          },
                          {
                            key: "item.update",
                            fn: function (ref) {
                              var item = ref.item
                              return [
                                _vm.globalViewOption("DeliverRouteUpdate") &&
                                item.state_id == 25
                                  ? _c(
                                      "v-tooltip",
                                      {
                                        attrs: { top: "" },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "activator",
                                              fn: function (ref) {
                                                var on = ref.on
                                                var attrs = ref.attrs
                                                return [
                                                  _c(
                                                    "a",
                                                    _vm._g(
                                                      _vm._b(
                                                        {},
                                                        "a",
                                                        attrs,
                                                        false
                                                      ),
                                                      on
                                                    ),
                                                    [
                                                      _c(
                                                        "router-link",
                                                        {
                                                          staticClass:
                                                            "btn btn-primary btn-m",
                                                          attrs: {
                                                            to: {
                                                              name: "DeliverRouteUpdate",
                                                              params: {
                                                                id: item.id,
                                                              },
                                                            },
                                                          },
                                                        },
                                                        [
                                                          _c("small", [
                                                            _c("i", {
                                                              staticClass:
                                                                "bi bi-pencil-square",
                                                            }),
                                                          ]),
                                                        ]
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                ]
                                              },
                                            },
                                          ],
                                          null,
                                          true
                                        ),
                                      },
                                      [
                                        _vm._v(" "),
                                        _c("small", [_vm._v("Editar")]),
                                      ]
                                    )
                                  : _c(
                                      "button",
                                      {
                                        staticClass: "btn btn-primary btn-m",
                                        attrs: { disabled: "" },
                                      },
                                      [
                                        _c("small", [
                                          _c("i", {
                                            staticClass: "bi bi-pencil-square",
                                          }),
                                        ]),
                                      ]
                                    ),
                              ]
                            },
                          },
                          {
                            key: "item.packages",
                            fn: function (ref) {
                              var item = ref.item
                              return [
                                _c(
                                  "v-tooltip",
                                  {
                                    attrs: { top: "" },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "activator",
                                          fn: function (ref) {
                                            var on = ref.on
                                            var attrs = ref.attrs
                                            return [
                                              _c(
                                                "a",
                                                _vm._g(
                                                  _vm._b({}, "a", attrs, false),
                                                  on
                                                ),
                                                [
                                                  _c(
                                                    "router-link",
                                                    {
                                                      staticClass:
                                                        "btn btn-orange btn-m",
                                                      attrs: {
                                                        to: {
                                                          name: "DeliverRoutePackages",
                                                          params: {
                                                            id: item.id,
                                                          },
                                                        },
                                                      },
                                                    },
                                                    [
                                                      _c("small", [
                                                        _c("i", {
                                                          staticClass:
                                                            "fa-solid fa-cubes",
                                                        }),
                                                      ]),
                                                    ]
                                                  ),
                                                ],
                                                1
                                              ),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      true
                                    ),
                                  },
                                  [_vm._v(" "), _c("small", [_vm._v("Abrir")])]
                                ),
                              ]
                            },
                          },
                          {
                            key: "item.delete",
                            fn: function (ref) {
                              var item = ref.item
                              return [
                                _vm.globalViewOption("DeliverRouteDelete") &&
                                item.state_id == 25
                                  ? _c(
                                      "v-tooltip",
                                      {
                                        attrs: { top: "" },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "activator",
                                              fn: function (ref) {
                                                var on = ref.on
                                                var attrs = ref.attrs
                                                return [
                                                  _c(
                                                    "button",
                                                    _vm._g(
                                                      _vm._b(
                                                        {
                                                          staticClass:
                                                            "btn btn-danger btn-m",
                                                          attrs: {
                                                            type: "button",
                                                          },
                                                          on: {
                                                            click: function (
                                                              $event
                                                            ) {
                                                              return _vm.DELETE(
                                                                item.id
                                                              )
                                                            },
                                                          },
                                                        },
                                                        "button",
                                                        attrs,
                                                        false
                                                      ),
                                                      on
                                                    ),
                                                    [
                                                      _c("small", [
                                                        _c("i", {
                                                          staticClass:
                                                            "bi bi-trash3",
                                                        }),
                                                      ]),
                                                    ]
                                                  ),
                                                ]
                                              },
                                            },
                                          ],
                                          null,
                                          true
                                        ),
                                      },
                                      [
                                        _vm._v(" "),
                                        _c("small", [_vm._v("Eliminar")]),
                                      ]
                                    )
                                  : _c(
                                      "button",
                                      {
                                        staticClass: "btn btn-danger btn-m",
                                        attrs: { disabled: "" },
                                      },
                                      [
                                        _c("small", [
                                          _c("i", {
                                            staticClass: "bi bi-trash3",
                                          }),
                                        ]),
                                      ]
                                    ),
                              ]
                            },
                          },
                          {
                            key: "item.print",
                            fn: function (ref) {
                              var item = ref.item
                              var index = ref.index
                              return [
                                _c(
                                  "div",
                                  { staticClass: "d-flex gap-3" },
                                  [
                                    _c(
                                      "v-tooltip",
                                      {
                                        attrs: { top: "" },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "activator",
                                              fn: function (ref) {
                                                var on = ref.on
                                                var attrs = ref.attrs
                                                return [
                                                  _c(
                                                    "button",
                                                    _vm._g(
                                                      _vm._b(
                                                        {
                                                          staticClass:
                                                            "btn btn-neutral btn-m",
                                                          attrs: {
                                                            type: "button",
                                                          },
                                                          on: {
                                                            click: function (
                                                              $event
                                                            ) {
                                                              return _vm.PRINT(
                                                                item.id,
                                                                index
                                                              )
                                                            },
                                                          },
                                                        },
                                                        "button",
                                                        attrs,
                                                        false
                                                      ),
                                                      on
                                                    ),
                                                    [
                                                      _c(
                                                        "small",
                                                        {
                                                          staticClass:
                                                            "d-flex justify-content-center align-items-center",
                                                        },
                                                        [
                                                          _vm.loading ==
                                                            "print" &&
                                                          _vm.loadings.filter(
                                                            function (e) {
                                                              return e == index
                                                            }
                                                          ).length == 1
                                                            ? _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "spinner-border spinner-border-sm mb-0",
                                                                  attrs: {
                                                                    role: "status",
                                                                  },
                                                                },
                                                                [
                                                                  _c(
                                                                    "span",
                                                                    {
                                                                      staticClass:
                                                                        "sr-only",
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        "Loading..."
                                                                      ),
                                                                    ]
                                                                  ),
                                                                ]
                                                              )
                                                            : _c("i", {
                                                                staticClass:
                                                                  "bi bi-printer",
                                                              }),
                                                        ]
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              },
                                            },
                                          ],
                                          null,
                                          true
                                        ),
                                      },
                                      [
                                        _vm._v(" "),
                                        _c("small", [_vm._v("Imprimir")]),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                              ]
                            },
                          },
                          {
                            key: "item.deliver",
                            fn: function (ref) {
                              var item = ref.item
                              return [
                                _c("div", { staticClass: "d-flex" }, [
                                  item.state_id == 26
                                    ? _c(
                                        "div",
                                        { staticClass: "mr-2" },
                                        [
                                          _c(
                                            "v-tooltip",
                                            {
                                              attrs: { top: "" },
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "activator",
                                                    fn: function (ref) {
                                                      var on = ref.on
                                                      var attrs = ref.attrs
                                                      return [
                                                        _c(
                                                          "button",
                                                          _vm._g(
                                                            _vm._b(
                                                              {
                                                                staticClass:
                                                                  "btn btn-m btn-danger",
                                                                attrs: {
                                                                  type: "button",
                                                                  disabled:
                                                                    item.state_id ==
                                                                    27,
                                                                },
                                                                on: {
                                                                  click:
                                                                    function (
                                                                      $event
                                                                    ) {
                                                                      return _vm.ACTION(
                                                                        item,
                                                                        true
                                                                      )
                                                                    },
                                                                },
                                                              },
                                                              "button",
                                                              attrs,
                                                              false
                                                            ),
                                                            on
                                                          ),
                                                          [
                                                            _c("small", [
                                                              _c("i", {
                                                                staticClass:
                                                                  "fa-solid fa-truck-fast fa-flip-horizontal",
                                                              }),
                                                            ]),
                                                          ]
                                                        ),
                                                      ]
                                                    },
                                                  },
                                                ],
                                                null,
                                                true
                                              ),
                                            },
                                            [
                                              _vm._v(" "),
                                              _c("small", [_vm._v("Devolver")]),
                                            ]
                                          ),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    [
                                      _c(
                                        "v-tooltip",
                                        {
                                          attrs: { top: "" },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "activator",
                                                fn: function (ref) {
                                                  var on = ref.on
                                                  var attrs = ref.attrs
                                                  return [
                                                    _c(
                                                      "button",
                                                      _vm._g(
                                                        _vm._b(
                                                          {
                                                            staticClass:
                                                              "btn btn-m",
                                                            class:
                                                              item.state_id ==
                                                              25
                                                                ? "btn-info"
                                                                : "btn-success",
                                                            attrs: {
                                                              type: "button",
                                                              disabled:
                                                                item.state_id ==
                                                                27,
                                                            },
                                                            on: {
                                                              click: function (
                                                                $event
                                                              ) {
                                                                return _vm.ACTION(
                                                                  item
                                                                )
                                                              },
                                                            },
                                                          },
                                                          "button",
                                                          attrs,
                                                          false
                                                        ),
                                                        on
                                                      ),
                                                      [
                                                        _c("small", [
                                                          _c("i", {
                                                            class:
                                                              item.state_id ==
                                                              25
                                                                ? "fa-solid fa-truck-fast"
                                                                : "fa-solid fa-check",
                                                          }),
                                                        ]),
                                                      ]
                                                    ),
                                                  ]
                                                },
                                              },
                                            ],
                                            null,
                                            true
                                          ),
                                        },
                                        [
                                          _vm._v(" "),
                                          _c("small", [
                                            _vm._v(
                                              _vm._s(
                                                item.state_id == 25
                                                  ? "Entregar"
                                                  : "Completar"
                                              )
                                            ),
                                          ]),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                ]),
                              ]
                            },
                          },
                        ],
                        null,
                        true
                      ),
                    }),
                  ],
                ],
                2
              ),
            ]),
          ]),
        ]),
      ]),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-sm col-12" }, [
      _c("h1", { staticClass: "h2 ls-tight" }, [_vm._v("Rutas de entrega")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "input-group-prepend" }, [
      _c("span", { staticClass: "input-group-text pe-2 text-sm" }, [
        _c("i", { staticClass: "fa-solid fa-hashtag" }),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "card-header bg-white" }, [
      _c("h5", { staticClass: "me-auto" }, [_vm._v("Listado")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }